import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <Route key="/business/technologies/" element={<DefaultConsumerLayout />}>
    <Route
      path="business/technologies/:feature"
      element={<AsyncPage />}
    />
  </Route>,
];
